import { Stack, Typography, Link as MuiLink, Divider, Box, Breadcrumbs, Paper, Button, Chip } from '@mui/material';
import React from 'react';
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import {
    Home as HomeIcon,
    Business as BusinessIcon,
    People as PeopleIcon,
    ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import MainCard from 'ui-component/cards/MainCard';

// ==============================|| LEADGEN DATA LAYOUT ||============================== //

function LeadGenDataLayout() {
    const location = useLocation();
    const navigate = useNavigate();
    const { exhibitorId, staffId } = useParams();
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const eventIdIndex = pathSegments.findIndex(seg => seg.match(/^\d+$/));
    const eventId = eventIdIndex !== -1 ? pathSegments[eventIdIndex] : null;

    return (
        <Box>
            <Paper
                elevation={0}
                sx={{
                    p: 2,
                    mb: 2,
                    bgcolor: 'background.default',
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                }}
            >
                <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{ mb: 1 }}>
                    <Breadcrumbs aria-label='breadcrumb'>
                        <MuiLink
                            component={Link}
                            to={`/${eventId}/leadgeneration`}
                            sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
                            color='inherit'
                        >
                            <HomeIcon sx={{ mr: 0.5 }} fontSize='inherit' />
                            Lead Generation
                        </MuiLink>
                        {exhibitorId && (
                            <Typography color='text.primary' sx={{ display: 'flex', alignItems: 'center' }}>
                                <BusinessIcon sx={{ mr: 0.5 }} fontSize='inherit' />
                                Stand Details
                            </Typography>
                        )}
                        {staffId && (
                            <Typography color='text.primary' sx={{ display: 'flex', alignItems: 'center' }}>
                                <PeopleIcon sx={{ mr: 0.5 }} fontSize='inherit' />
                                Staff Details
                            </Typography>
                        )}
                    </Breadcrumbs>
                    <Button
                        variant='outlined'
                        size='small'
                        startIcon={<ArrowBackIcon />}
                        onClick={() => navigate(`/${eventId}/leadgeneration`)}
                    >
                        Back to List
                    </Button>
                </Stack>
            </Paper>
            <Outlet />
        </Box>
    );
}

export default LeadGenDataLayout;
